/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from 'react';

export const PricingFrequencyContext = createContext({
  isYearlyFrequency: true,
  setIsYearlyFrequency: (value: boolean) => {},
});

export const usePricingFrequency = () => {
  const context = useContext(PricingFrequencyContext);
  if (!context) {
    throw new Error('usePricingFrequencyContext must be used within a PricingFrequencyContext');
  }
  return context;
};
